/** @format */

import {
  CategoriesFromQuery,
  CompanyFromQuery,
  GroupType,
  ProjectGroupInterface,
  ProjectTableInterface,
} from '../types';
import {getUniqueObjects} from './getUniqueObjects';
import {mapCompany} from './mapCompany';

interface Options {
  data: ReadonlyArray<CompanyFromQuery>;
  chosenFiltering: GroupType;
  categories: CategoriesFromQuery[];
}

const mapCompanies = ({data, chosenFiltering, categories}: Options): ProjectGroupInterface[] => {
  if (chosenFiltering === 'settings') {
    return [];
  }

  const tagsList = data
    .map(company => company.tags)
    .flat()
    .filter(tag => {
      return tag.category?.id === chosenFiltering;
    });

  const tags = getUniqueObjects(tagsList, 'id').map(tag => tag.id);

  const companiesWithoutCategory: ProjectTableInterface[] = data
    .filter(v => !v.tags.some(tag => tags.includes(String(tag.id))))
    .flatMap(item => mapCompany(item));

  if (chosenFiltering === 'default') {
    return [
      {
        id: 'no-group',
        projects: companiesWithoutCategory,
      },
    ];
  }

  const categoryTags = categories.map(v => v.tags).flat();

  const companiesWithCategory: ProjectGroupInterface[] = tags.map(tag => {
    const title = categoryTags.find(tagDto => tagDto?.id === tag)?.name || '';
    return {
      id: tag,
      title,
      projects: data.filter(v => v.tags.some(t => t.id === tag)).flatMap(item => mapCompany(item)),
    };
  });

  const result = companiesWithCategory;

  if (companiesWithoutCategory.length) {
    result.push({
      id: 'no-group',
      title: 'Проекты без группы',
      projects: companiesWithoutCategory,
    });
  }

  return result;
};

export {mapCompanies};
